import Button from "components/ui/Button";
import { formatDateString } from "../HomeDashboard";
import { defaultActionType } from "../WorkFlowActions";

export type WFA = {
  workflowInstances__Id: number;
  workflowInstances__Name: string | null;
  workflowActionInstances__Id: number | null;
  workflowApprovalInstances__Id: number | null;
  restrictedWorkflow__bWorkflowAction: boolean;
  restrictedWorkflow__MessageText: string | null;
  restrictedWorkflow__Description: string | null;
  restrictedWorkflow__DateReceived: string | null;
  sites__SitesName: string | null;
  sites__Id: number | null;
  sites__ClientID: number | null;
  projects__Id: number | null;
  projectTypes__Type: string | null;
  programmes__Name: string | null;
  communications__Id: number | null;
};
export const WorkFlowActionItem = ({
  wfa,
  openMenu,
  closeMenu,
  isDisabled,
  isReviewDisabled,
}: {
  wfa: WFA;
  openMenu?: ({ id, type }: { id: any; type?: "Action" | "Approval" | "Notification" }) => void;
  closeMenu?: () => void;
  isDisabled?: (permissionKey?: string) => boolean | undefined;
  isReviewDisabled?: (data: WFA) => boolean | undefined;
}) => {
  const {
    workflowInstances__Id,
    workflowInstances__Name,
    workflowActionInstances__Id,
    workflowApprovalInstances__Id,
    restrictedWorkflow__bWorkflowAction,
    restrictedWorkflow__MessageText,
    restrictedWorkflow__Description,
    restrictedWorkflow__DateReceived,
    sites__SitesName,
    sites__Id,
    sites__ClientID,
    projects__Id,
    projectTypes__Type,
    programmes__Name,
    communications__Id,
  } = wfa;

  let parsedMessage = restrictedWorkflow__MessageText;

  if (parsedMessage && parsedMessage.length > 30) {
    parsedMessage = `${parsedMessage.slice(0, 30)}...`;
  }

  return (
    <div className="WorkFlowActionItem">
      <div className="Column ActionColumn WorkflowName">
        <div className="ColumnValue" style={{ marginBottom: "0" }}>
          {workflowInstances__Name ?? "-"}
        </div>
        {/* <h3 style={{ marginBottom: "0" }}>{restrictedWorkflow__MessageText}</h3> */}
      </div>

      <div className="Column SiteColumn">
        <div className="ColumnName">
          <span>Site:</span>
        </div>
        <div className="ColumnValue SiteInfo">
          <span className="SiteName">{sites__SitesName}</span>
        </div>
      </div>

      <div className="Column ID">
        <div className="ColumnValue">
          <span className="SiteID">{`${sites__Id}`}</span>
        </div>
      </div>

      <div className="Column ID">
        <div className="ColumnValue">
          <span className="ClientID">{`${sites__ClientID ?? "-"}`}</span>
        </div>
      </div>

      <div className="Column">
        <div className="ColumnName">
          <span>Project Type: </span>
        </div>

        <div className="ColumnValue">
          <span>{projectTypes__Type}</span>
        </div>
      </div>
      <div className="Column">
        <div className="ColumnName">
          <span>Programme: </span>
        </div>
        <div className="ColumnValue">
          <span>{programmes__Name}</span>
        </div>
      </div>
      <div className="Column DateColumn">
        <div className="ColumnName">
          <span> Date Created:</span>
        </div>
        <div className="ColumnValue">
          <span>
            {restrictedWorkflow__DateReceived
              ? formatDateString(
                  restrictedWorkflow__DateReceived,
                  "dd - MMM - yyyy"
                )
              : "-"}
          </span>
        </div>
      </div>

      <Button
        onClick={() => {
          openMenu &&
            openMenu({
              id: communications__Id 
                  ? communications__Id 
                  : (restrictedWorkflow__bWorkflowAction 
                      ? workflowActionInstances__Id 
                      : workflowApprovalInstances__Id),
              type: communications__Id ? "Notification" : restrictedWorkflow__bWorkflowAction ? "Action" : "Approval",
            });
        }}
        type="button"
        disabled={
          isReviewDisabled
            ? isReviewDisabled(wfa)
            : isDisabled &&
              (restrictedWorkflow__bWorkflowAction
                ? isDisabled(
                    defaultActionType.permissionKeys[0] ?? "review-action"
                  )
                : isDisabled(
                    defaultActionType.permissionKeys[1] ?? "review-approval"
                  ))
        }
        className="ReviewButton"
      >
        <div className="Text">Review</div>
      </Button>
      {/* </div> */}
    </div>
  );
};

const MinWidth = {
  Principle: "170px",
  Project: "300px",
  Prpgramme: "140px",
  DateReceived: "170px",
};
